import React, { Component } from "react";
import renderHTML from "react-render-html";
import { Redirect } from "react-router-dom";

import PropTypes from "prop-types";

import { APIHandler, DataHandler, StorageHandler, LinkButton } from "C4";

import { appContentUrl, storageKeys } from "settings";

import RetainContent from "./RetainContent";

import Sidebar from "./Sidebar";

const verify = () =>
  StorageHandler.load(storageKeys.user).then((user) => {
    if (!user) return <Redirect to="/login" />;

    return DataHandler.matchAppId().then((appId) =>
      DataHandler.checkKey(
        storageKeys.chapters,
        APIHandler.getChapters(appId),
        true
      ).then((chapters) => {
        if (!chapters) return <Redirect to="/main/retain" />;
        return { value: true, chapters };
      })
    );
  });

export default class RetainContentView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: -1,
      verified: false,
      chapters: null,
      pages: null,
      items: [],
      buttons: [],
      redirect: null,
    };

    this.switchPage = this.switchPage.bind(this);
  }

  componentDidMount() {
    document.querySelector("html").addEventListener("keydown", this.switchPage);

    this.initList();
  }

  componentDidUpdate() {
    const { verified } = this.state;
    if (!verified) {
      this.setList();
    }
  }

  componentWillUnmount() {
    document
      .querySelector("html")
      .removeEventListener("keydown", this.switchPage);
  }

  getPages() {
    const { chapterId } = this.props.match.params;
    return StorageHandler.load(storageKeys.pages).then((localPages) => {
      if (localPages) {
        const [final] = localPages.filter((page) => page.upID !== undefined);
        if (final && final.upID.indexOf(chapterId) === 0) return localPages;
      }
      return APIHandler.getTrainingPages(chapterId).then((pages) => {
        StorageHandler.save(storageKeys.pages, pages);
        return pages;
      });
    });
  }

  async setList() {
    const { chapterId, pageId } = this.props.match.params;
    const pages = await this.getPages();

    const items = pages
      .map((page, i) => ({
        name: page.title || page.pageType,
        type: page.pageType,
        active: page.upID === pages[pageId].upID,
        index: i,
        onClick: () => {
          this.setState({
            verified: false,
            redirect: `/main/ret/chapter/${chapterId}/${i}`,
          });
        },
      }))
      .filter(({ type }) => type !== undefined && type !== "Final-Page");

    this.setButtons(pages[+pageId]);
    this.setState({
      verified: true,
      items,
      pages,
    });
  }

  setButtons(page) {
    const buttons = [];
    let index = 1;

    if (page !== undefined) {
      index = 1;
      Object.keys(page).forEach((link) => {
        const links = [page[`link${index}`], page[`linkType${index}`]].every(
          (val) => val !== undefined && val.length > 0
        );
        const linksValid = page.question === undefined && links;
        if (link === `link${index}` && linksValid) {
          buttons.push(
            <LinkButton
              key={page[`linkType${index}`]}
              link={page[`link${index}`]}
              type={page[`linkType${index}`]}
            />
          );
          index += 1;
        }
      });
      this.setState({ buttons });
    }
  }

  async initList() {
    const appId = await DataHandler.matchAppId();
    const verified = await verify();
    const { value, chapters } = verified;

    this.setState({
      appId,
      verified: value || verified,
      chapters: chapters || null,
    });

    this.setList();
  }

  switchPage(e) {
    const { match } = this.props;
    const { pageId, chapterId } = match.params;
    const { items } = this.state;

    const i = items.map(({ index }) => index).indexOf(+pageId);
    let redirect = null;

    if (e.key === "ArrowDown" && i < items.length - 1) {
      e.preventDefault();
      redirect = items[i + 1].index;
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      redirect = items[0].index;
    }
    if (e.key === "ArrowUp" && i > 0) {
      e.preventDefault();
      redirect = items[i - 1].index;
    } else if (e.key === "ArrowUp" && i === 0) {
      e.preventDefault();
      redirect = items[items.length - 1].index;
    }

    if (redirect !== null) {
      this.setState({
        verified: false,
        redirect: `/main/ret/chapter/${chapterId}/${redirect}`,
      });
    }
  }

  verifyUrl() {
    const { url, params } = this.props.match;
    const { pageId, chapterId } = params;
    const { chapters, pages } = this.state;
    if (chapters && pages) {
      return chapters.app.some(
        (chapter) => +chapter.chapterID === +chapterId
      ) &&
        +pageId >= 0 &&
        +pageId < pages.length ? null : (
        <Redirect to={url.substring(0, url.indexOf(chapterId))} />
      );
    }
    return null;
  }

  render() {
    const {
      url,
      params: { chapterId, pageId },
    } = this.props.match;
    const { appId, verified, items, pages, chapters, buttons, redirect } =
      this.state;

    return (
      <section className="retain container">
        {verified !== true ? verified : null}
        {items && chapters && (
          <Sidebar
            appId={appId}
            items={items}
            image={
              chapters.app.filter(
                (chapter) => +chapter.chapterID === +chapterId
              )[0].chapterImage
            }
          />
        )}
        {pages && (
          <RetainContent
            appId={appId}
            image={`${appContentUrl}${appId}/${pages[pageId].image}`}
            summary={{
              title: pages[pageId].title,
              text: renderHTML(pages[pageId].summary),
            }}
            params={pages[pageId]}
            buttons={buttons}
          />
        )}
        {this.verifyUrl()}
        {redirect && redirect !== url && <Redirect to={redirect} />}
      </section>
    );
  }
}

RetainContentView.propTypes = {
  match: PropTypes.shape().isRequired,
};
